module.exports = __webpack_public_path__ + "static/media/logo_lienviet.bef196e3.svg";